import { type ComponentChildren, Fragment } from "preact";
import { FAB_SYMBOLS } from "../lib/symbols";

// Accept `}` or `]` as the closer: the upstream data has one malformed
// `{r]{r}` (Reality Refractor) and the model may echo it.
const TOKEN = /\{([a-zA-Z]+)[}\]]/g;

/**
 * Render card/rule text, replacing `{p}`-style placeholders with FAB symbols.
 * Adjacent symbols (`{r}{r}` = two resource points) render as separate icons.
 * Unknown tokens (e.g. `{t}`, `{u}`, `{c}`, `{x}`) are left as literal text.
 */
export function FabText({ text }: { text: string }) {
  const parts: ComponentChildren[] = [];
  let last = 0;

  for (const match of text.matchAll(TOKEN)) {
    const index = match.index ?? 0;
    if (index > last) parts.push(text.slice(last, index));

    const symbol = FAB_SYMBOLS[(match[1] ?? "").toLowerCase()];
    parts.push(
      symbol
        ? (
          <img
            class="fab-symbol"
            src={symbol.src}
            alt={symbol.label}
            title={symbol.label}
            draggable={false}
          />
        )
        : (
          match[0]
        ),
    );

    last = index + match[0].length;
  }

  if (last < text.length) parts.push(text.slice(last));

  return (
    <>
      {parts.map((part, index) => <Fragment key={index}>{part}</Fragment>)}
    </>
  );
}
